/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does compounding frequency change?`)
};

const es_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué cambia con la frecuencia de capitalización?`)
};

const de_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was verändert die Zinseszinsperiode?`)
};

const nl_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat wijzigt de renteverrekening?`)
};

const fr_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que change la fréquence de composition ?`)
};

const it_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa cambia la frequenza di capitalizzazione?`)
};

const pt_br2_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que a frequência de capitalização muda?`)
};

const pt_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que diferença faz a frequência de capitalização?`)
};

const ja_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利計算期間は何を変えるのか?`)
};

const zh_cp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复利周期会带来什么变化？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq1_q", locale)
	if (locale === "en") return en_cp_faq1_q(inputs)
	if (locale === "es") return es_cp_faq1_q(inputs)
	if (locale === "de") return de_cp_faq1_q(inputs)
	if (locale === "nl") return nl_cp_faq1_q(inputs)
	if (locale === "fr") return fr_cp_faq1_q(inputs)
	if (locale === "it") return it_cp_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq1_q(inputs)
	if (locale === "pt") return pt_cp_faq1_q(inputs)
	if (locale === "ja") return ja_cp_faq1_q(inputs)
	return zh_cp_faq1_q(inputs)
};